import React, {createContext, useState, useEffect, ReactNode} from 'react';

interface App {
  application: string;
  description: string;
  image_url:string;
}
interface AppsContextType {
  apps: App[];
  setApps: React.Dispatch<React.SetStateAction<string[]>>;
}
export const AppsContext = createContext<AppsContextType | undefined>(undefined);

export const AppsProvider:React.FC<{ children: ReactNode }> = ({ children }) => {
  const [apps, setApps] = useState(() => {
    try {
      const savedApps = localStorage.getItem('apps');
      return savedApps ? JSON.parse(savedApps) : [];
    } catch (error) {
      console.error('Error loading apps from localStorage', error);
      return [];
    }
  });

  useEffect(() => {
    try {
      const appsString = JSON.stringify(apps);
      localStorage.setItem('apps', appsString);
    } catch (error) {
      console.error('Error saving apps to localStorage', error);
    }
  }, [apps]);

  return (
    <AppsContext.Provider value={{ apps, setApps }}>
      {children}
    </AppsContext.Provider>
  );
};